import React from "react";
import { Checkbox, TableCell, TableHead, TableRow } from "@material-ui/core";
import TableSortLabel from "@material-ui/core/TableSortLabel";

export default function TableHeader(props) {
  const {
    headCells,
    onRequestSort,
    orderBy,
    order,
    hasActions,
    multiRowActions,
    multiSelectField,
    selectRatio,
    setSelectedRows,
    rows,
  } = props;

  const createSortHandler = (property) => (event) => {
    onRequestSort(event, property);
  };
  const onSelectAllClick = () => {
    const rowsFields = rows.map((r) => r[multiSelectField]);
    if (!selectRatio) {
      return setSelectedRows((rs) => {
        const _rows = new Set(rs);
        rowsFields.forEach((r) => {
          _rows.add(r);
        });
        return [..._rows];
      });
    }
    return setSelectedRows((rs) => {
      return rs.filter((r) => !rowsFields.includes(r));
    });
  };
  return (
    <TableHead>
      <TableRow>
        {Boolean(multiRowActions) && (
          <TableCell padding="checkbox">
            <Checkbox
              indeterminate={selectRatio < 1 && selectRatio > 0}
              checked={selectRatio === 1}
              onChange={onSelectAllClick}
            />
          </TableCell>
        )}
        {headCells.map((cell) =>
          cell.hidden ? null : (
            <TableCell
              key={cell.title}
              sortDirection={
                orderBy === cell.field ? order.toLowerCase() : false
              }
            >
              {cell.disableSort ? (
                cell.title
              ) : (
                <TableSortLabel
                  active={orderBy === cell.field}
                  direction={(orderBy === cell.field
                    ? order
                    : "ASC"
                  ).toLowerCase()}
                  onClick={createSortHandler(cell.field)}
                >
                  {cell.title}
                  {orderBy === cell.field ? (
                    <span className="visually-hidden">
                      {order === "DESC"
                        ? "sorted descending"
                        : "sorted ascending"}
                    </span>
                  ) : null}
                </TableSortLabel>
              )}
            </TableCell>
          )
        )}
        {hasActions ? <TableCell className="w-1">عملیات</TableCell> : null}
      </TableRow>
    </TableHead>
  );
}
